<template>
	<div style="width: 100%;height: 500px;">
	</div>
</template>

<script>
	import 'leaflet/dist/leaflet.css'
	import L from 'leaflet'
	export default {
		props: {
			center: {},
			numberCount: {
				type: Number,
				default: 10
			}
		},
		data() {
			return {
				map: null,
				layerGroup: null,
				layerGroupArr: [],
				layerControl: null,
				markerGroup: null,
				circle: null,
				markIcon: L.icon({
					iconUrl: require('./../../../static/img/icon.png'),
					iconSize: [24, 31], // size of the icon
					iconAnchor: [12, 31],
					popupAnchor: [-1, -20]
				})
			}
		},
		watch: {
			numberCount: {
				handler() {
					if(this.circle) this.circle.setRadius(this.numberCount * 1000)
				},
				deep: true
			}
		},
		mounted() {
				this.init()
			// this.$nextTick(()=>{
			// })
		},
		methods: {
			init() {
				let normal1 = L.tileLayer('http://webst0{s}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}&lang=zh_cn', {
					subdomains: [ '1', '2', '3', '4']
				})
				let normal2 = L.tileLayer('http://webst0{s}.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}&lang=zh_cn', {
					subdomains: ['1', '2', '3', '4']
				})
				let normal = [
					L.layerGroup([normal1]),
					L.layerGroup([normal2])
				]
				this.$nextTick(()=>{
					var map = L.map(this.$el, {
						center: this.center,
						zoom: 10,
						layers: normal
					});
					L.marker(this.center, {
						icon: this.markIcon
					}).addTo(map)
					this.circle = L.circle(this.center, {
						color: '#20a0ff',
						fillColor: '#20a0ff',
						fillOpacity: 0.1,
						radius: this.numberCount * 1000
					}).addTo(map);
				})
			},
		}
	}
</script>

<style></style>



// WEBPACK FOOTER //
// map.vue?c114d8c2